import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/img/defaultUser.jpg'


const _hoisted_1 = { class: "networkUser" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  style: {"object-fit":"contain"}
}
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "qualification" }
const _hoisted_7 = { class: "code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_whatsapp = _resolveComponent("icon-whatsapp")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.canWa && _ctx.item.telephone)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.whatsappLink,
          target: "_blank",
          class: "whatsapp",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_component_icon_whatsapp)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.item.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.item.image.publicUrl
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.completeName), 1),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Qualifica:",
          text: "Qualifica:"
        })
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.item.qualification.qualificationCode), 1)
    ])
  ]))
}